import React, { useState, useEffect, useContext } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { createMuiTheme, AppBar, Toolbar, IconButton, Typography, TextField, Button, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from '@material-ui/lab/Autocomplete';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { HttpService } from "../../../apiAuthorization/httpService";
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import GridItem from "../../grid/gridItem.js";
import GridContainer from "../../grid/gridContainer.js";
import AlertDialog from '../../common/alertDialog';
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);

export default function UserPOSAccountAdd(props) {
    const classes = useStyles();
    const user = props.model.length === 0 ? [] : props.model;
    const { theme } = useContext(Theme);
    const [siteId, setSiteId] = useState(0);
    const [locations, setLocations] = useState([]);
    const [alertOpen, setAlertOpen] = React.useState(false);
    const [severity, setSeverity] = React.useState('');
    const [errorMessage, setErrorMessage] = React.useState('');
    const [backDrop, setBackDrop] = useState(true);
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const alertClose = () => {
        setAlertOpen(false);
    };

    const savePOSAccount = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (siteId) {
            var location = locations.filter(x => x.GeoLocationId === siteId);
            setBackDrop(true);
            HttpService.post('/User/SavePOSAccount', {
                Id: 0,
                SiteId: siteId,
                AppUserName: user.userName,
                FirstName: user.firstName,
                MiddleName: user.middleName,
                LastName: user.lastName,
                IsAttendant: false,
                IsDeleted: false,
                IsManager: false,
                //IsAttritionAssociate: false
            })
            .then((result) => {
                if (result.error) {
                    setErrorMessage(result.message);
                    setSeverity('error');
                    setAlertOpen(true);
                }
                else {
                    var data = result.data;
                    data.LocationPath = location[0].GeoLocationBranchName;
                    props.refreshGrid(data);
                    props.parentCallback();
                }
            },
            (error) => {
                console.log(error);
            });
        }
        else if (goBack) {
            props.parentCallback();
        }
    };

    const getLocations = () => {
        HttpService.post('/User/GetPOSLocations', {
            AppUserName: user.userName
        })
        .then((result) => {
            setLocations(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
        });
    };

    useEffect(() => {
        getLocations();
        // eslint-disable-next-line
    }, []);

    return (<>
        <Backdrop className={classes.backdrop} id="posAccountAddBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => savePOSAccount(true)} aria-label="back">
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Typography variant="h6" className={classes.title}>Add POS Site</Typography>
                    </Grid>
                    <Grid item>
                        <StatusIcon />
                    </Grid>
                </Grid>
                <Grid container justify="flex-end">
                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                        <CloseIcon />
                    </Fab>
                    <SmallMenu modified={modified} saveCallback={() => savePOSAccount(false)} />
                </Grid>
            </Toolbar>
        </AppBar>
        <GridContainer style={{ justifyContent: 'center' }}>
            <GridItem xs={6} sm={6} md={6}>
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} autoComplete="off" onSubmit={() => savePOSAccount(false)} style={{ width: "100%", display: "block" }}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={locations}
                                getOptionLabel={(option) => option.GeoLocationBranchName}
                                onChange={(event, option) => {
                                    setSiteId(option.GeoLocationId);
                                    setModified(true);
                                }}
                                style={{ width: "100%", clear: "both" }}
                                renderInput={(params) => <TextField {...params} label="Select Site Name" variant="outlined" />}
                            />
                            <br /> <br />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                className={classes.button}
                                style={{ background: currentTheme.secondary, width: "100px", float: 'right' }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
        <AlertDialog open={alertOpen} close={alertClose} message={errorMessage} severity={severity} />
    </>
    );
}
